module.exports = __webpack_public_path__ + "static/media/bg_icon_3.b9dc9c25.svg";